import { useContext } from "react";
import TransferCheck from "./TransferCheck";
import {
  STEP_ANNUITY_CONTACT,
  STEP_IRA_EXIT_SCREEN,
  STEP_SCHEDULE_PHONE_CALL,
  STEP_TRANSFER_TASKS,
} from "../../class/transferDetails";
import { TransferContext } from "../../context/TransferContext";
import { AppContext } from "../../context/AppContext";
import { BRIDGE_DEMO, BRIDGE_DEVELOPMENT, BRIDGE_PRODUCTION } from "../../typings";

const PostTransfer = () => {
  const { appEnv, flow } = useContext(AppContext);
  const { goToScreen, navigateToHomeScreen, isPhoneCallNeeded, transferIntentDetails, isPendingIRA, transferTasks } =
    useContext(TransferContext);

  const goToTransferTasks = () => goToScreen(STEP_TRANSFER_TASKS);

  // need to check if schedule call is needed
  const onNextHandler = () => {
    if (isPhoneCallNeeded && appEnv === BRIDGE_PRODUCTION) {
      goToScreen(STEP_SCHEDULE_PHONE_CALL);
    } else if (flow === "Annuity") {
      goToScreen(STEP_ANNUITY_CONTACT);
    } else if (isPendingIRA) {
      goToScreen(STEP_IRA_EXIT_SCREEN);
    } else {
      navigateToHomeScreen();
    }
  };
  return (
    <TransferCheck
      onNext={onNextHandler}
      goToTransferTasks={goToTransferTasks}
      transferTasks={transferTasks}
      phoneCallNeeded={
        appEnv === BRIDGE_DEMO || appEnv === BRIDGE_DEVELOPMENT
          ? false
          : transferIntentDetails?.primaryDestination?.isOpened
      }
    />
  );
};
export default PostTransfer;
